"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _styles = require("@mui/material/styles");
var _CButton = _interopRequireDefault(require("./CButton"));
var _DisplayField = _interopRequireDefault(require("./DisplayField"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const GridButton = (0, _styles.styled)(_Grid.default)({
  flexGrow: 0
});
const GridLabel = (0, _styles.styled)(_Grid.default)({
  flexGrow: 100
});
const HiddenInput = (0, _styles.styled)('input')({
  display: 'none'
});

/**
 * ファイル入力部品
 * @prop {func} onChange - 変更時のイベント<br/>
 * シグネチャ：(value:file):void
 * @prop {bool} [noDisplay] - trueの時ファイル名を表示しない
 * @prop {string} [dispFileNm] - 初期表示ファイル名
 * @prop {func} onRef - Refコールバック
 */
class InputFile extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getUniqueStr", () => {
      return new Date().getTime().toString() + Math.floor(1000 * Math.random()).toString();
    });
    _defineProperty(this, "displayFileNm", () => {
      let name = '';
      if (this.state.file) {
        name = this.state.file.name;
      } else if (this.props.dispFileNm) {
        name = this.props.dispFileNm;
      }
      return name;
    });
    _defineProperty(this, "handleChangeFile", event => {
      const target = event.target.files[0];
      this.setState({
        file: target
      });
      this.props.onChange(target);
    });
    this.state = {
      file: null,
      fileInput: /*#__PURE__*/_react.default.createRef()
    };
    this.inputFieldId = 'upload' + this.getUniqueStr();
  }
  componentDidMount() {
    if (this.props.onRef) {
      this.props.onRef(this);
    }
  }
  componentWillUnmount() {
    if (this.props.onRef) {
      this.props.onRef(null);
    }
  }
  reSet() {
    this.setState({
      file: null
    });
    this.props.onChange(null);
  }
  render() {
    const {
      children,
      noDisplay,
      error,
      helperText
    } = this.props;
    let validateProps = {};
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HiddenInput, {
      type: "file",
      id: this.inputFieldId,
      ref: this.state.fileInput,
      onChange: this.handleChangeFile,
      onClick: e => {
        e.target.value = '';
      }
    }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, /*#__PURE__*/_react.default.createElement(GridButton, null, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: this.inputFieldId
    }, /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      component: "span"
    }, children))), !noDisplay && /*#__PURE__*/_react.default.createElement(GridLabel, null, /*#__PURE__*/_react.default.createElement(_DisplayField.default, _extends({}, validateProps, {
      error: !!error,
      helperText: helperText
    }), this.displayFileNm()))));
  }
}
InputFile.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  noDisplay: _propTypes.default.bool,
  onRef: _propTypes.default.func,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node
};
var _default = exports.default = (0, _reactIntl.injectIntl)(InputFile);